module.exports = __webpack_public_path__ + "static/media/search.061a32a3.jpg";